// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"466":"bba97e9f","787":"f4cd3357"}[chunkId] + ".chunk.js";
};